import { render, staticRenderFns } from "./AlarmSms.vue?vue&type=template&id=3969e188"
import script from "./AlarmSms.vue?vue&type=script&lang=js"
export * from "./AlarmSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports